import PropTypes from 'prop-types'
import React from 'react'
import classes from './DailyProducts.scss'

import New from './New'
import Pricelist from 'components/Pricelist'

export const DailyProducts = (props) => {
  return (
    <div className={classes['dual-view']}>
      <New {...props} partial />
      <Pricelist {...props} baseUrl='daily_products' partial editing />
    </div>
  )
}

DailyProducts.propTypes = {
  // state
  daily_product: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,

  // redux-form
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,

  // actions
  copy: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
}

export default DailyProducts



// WEBPACK FOOTER //
// ./src/components/DailyProducts/DailyProducts.js